import React from 'react'
import {
    Col,
    Row
} from 'react-bootstrap'

import TabsButtons from './buttons'
import TabsContents from './contents'


class Tabs extends React.Component {
    render() {
        return (

            <Row>
                <Col>
                    <div className='tab'>
                        <TabsButtons buttons={this.props.data} />

                        <div class="tab-content">
                            <TabsContents contents={this.props.data} />
                        </div>
                    </div>
                </Col>
            </Row>


        )
    }
}

export default Tabs;